export const CONFIDENCE_THRESHOLDS = { high: 80, medium: 60, directional: 40 };
export function confidenceLabel(score) {
    if (score >= CONFIDENCE_THRESHOLDS.high)
        return 'high';
    if (score >= CONFIDENCE_THRESHOLDS.medium)
        return 'medium';
    if (score >= CONFIDENCE_THRESHOLDS.directional)
        return 'directional';
    return 'low';
}
/** Display copy for confidence badges (C1 attribution-language rules: hedged, never "proven"). */
export const CONFIDENCE_LABEL_COPY = {
    high: 'High confidence',
    medium: 'Medium confidence',
    directional: 'Directional only',
    low: 'Low confidence / insufficient data',
};
// ─── Attributable halo (three-tier reporting) ────────────────────────────────
// Mirrors halo-api services/analytics/src/halo-v2/attributable-halo.ts and the
// /halo-summary endpoint — keep in sync.
export const QUIET_PRESSURE_MAX = 50;
export const ELEVATED_PRESSURE_MIN = 75; // exclusive: elevated means score > 75
export const GATE_REASON_COPY = {
    no_media_data: 'no baseline rows in range',
    insufficient_quiet_days: 'not enough quiet-media days to measure the noise floor (needs 20)',
    insufficient_elevated_days: 'not enough elevated-media days to attribute (needs 10)',
};
/** Same thresholds as the backend classifier (score 0 = no media data = quiet). */
export function classifyDay(pressureScore, isConfounded) {
    if (isConfounded)
        return 'confounded';
    if (pressureScore <= QUIET_PRESSURE_MAX)
        return 'quiet';
    if (pressureScore > ELEVATED_PRESSURE_MIN)
        return 'elevated';
    return 'buffer';
}
//# sourceMappingURL=halo-v2.js.map